// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-selector {
  display: flex;
  gap: 20px;
  align-items: center;
}
.option-selector .option-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
}
.option-selector .option-label .option-text {
  margin-right: 10px;
}
.option-selector .option-label .option-circle {
  width: 20px;
  height: 20px;
  border: 2px solid #888;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
.option-selector .option-label .option-circle:hover {
  border-color: #007bff;
}
.option-selector .option-label .option-circle.selected {
  border-color: #007bff;
  background: radial-gradient(circle, #007bff 40%, transparent 50%);
}
`, "",{"version":3,"sources":["webpack://./src/components/utils/OptionSelector.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AACJ;AAJA;EAMM,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AACN;AAVA;EAYQ,kBAAA;AACR;AAbA;EAgBQ,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAAR;AAEQ;EACE,qBAAA;AAAV;AAGQ;EACE,qBAAA;EACA,iEAAA;AADV","sourcesContent":[".option-selector {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n  \n    .option-label {\n      display: flex;\n      align-items: center;\n      cursor: pointer;\n      font-size: 16px;\n  \n      .option-text {\n        margin-right: 10px;\n      }\n  \n      .option-circle {\n        width: 20px;\n        height: 20px;\n        border: 2px solid #888;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.3s ease-in-out;\n  \n        &:hover {\n          border-color: #007bff;\n        }\n  \n        &.selected {\n          border-color: #007bff;\n          background: radial-gradient(circle, #007bff 40%, transparent 50%);\n        }\n      }\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
